import React, { useContext, useEffect, useState } from 'react';
import BasicDetail from './BasicDetail';
import { ReactComponent as BackIcon } from "assets/img/svg/BackArrow.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ActiveContact from './ActiveContact';
import { createSchoolHandler, editSchoolHandler, getDropdowns, getLogs, getSchoolDetail } from './utils';
import BranchMapping from './BranchMapping';
import Logs from './Logs';
import { branchTypeDropdown, checkValidation, departmentDropdown, getDisplayList, initialBasicDetail, jobTitleDropdown, jobTypeDropdown, schoolTypeDropdown } from './constant';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { useParams, useLocation } from "react-router";
import ALoader from 'views/pages/manage/common/a-loader';
import { RolePermissions } from 'appContext';
import { pages } from 'views/pages/manage/common/constant';
import { PermissionContext } from 'appContext';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { useHistory } from 'react-router';
const SchoolInfo = () => {
    const [basicForm, setBasicForm] = useState({})
    const [activeContactRows, setActiveContactRows] = useState([])
    const [branchMappingRows, setBranchMappingRows] = useState([])
    const [dropdown, setDropdown] = useState({})
    const [rowForm, setRowForm] = useState({})
    const [loader, setLoader] = useState(false)
    const [isView, setView] = useState(false)
    const [logsList, setLogsList] = useState([])
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const type = !!(queryParams.get("isView") == 'true');
    const schoolId = queryParams.get("schoolId");
    const history= useHistory()
    const [currentLogsPage, setCurrentPage] = useState(0);
    const [logsRowCount, setLogsRowCount] = useState(0);

    const userPermissions = RolePermissions(
        useContext(PermissionContext),
        pages["schoolMaster"]["id"]
    );
    const basicDetailRowFormHandler = (key, val, setForm) => {
        setForm((prev) => {
            const p = { ...prev, [key]: val }
            return p;
        })
    }

    useEffect(() => {
        fetchData(type)
        setView(type)

    }, [])

    const fetchData = async (type) => {

        setLoader(true)
        try{
        const p = await getDropdowns()
        const dropdowns = {
            city: p[0],
            state: p[1],
            country: p[2],
            // region: p[3],
            board: p[3],
            medium: p[4],
            businessArea: p[5],
            type: schoolTypeDropdown,
            jobTitle: jobTitleDropdown,
            department: departmentDropdown,
            jobType: jobTypeDropdown,
            branchType:branchTypeDropdown,
            status: [
                { label: 'ACTIVE', value: 'ACTIVE' },
                { label: 'INACTIVE', value: 'INACTIVE' }
            ]
        }
        if (type) {
            const rowList = await getSchoolDetail(schoolId)
            await getDetailLogs()
            const dispObj = getDisplayList(dropdowns, rowList)
            setBasicForm(dispObj?.basicDetail)
            setActiveContactRows(dispObj?.activeContact);
            setBranchMappingRows(dispObj?.branchMapping)
        }
        setDropdown(dropdowns)
    }
    catch(err){
        console.log(err)
    }
    finally{
        setLoader(false)
    }
    }

    const getDetailLogs= async (page=0)=>{
        const logs= await getLogs(schoolId,page)
            if(logs?.code==200){
                setLogsRowCount(logs?.data?.totalRecords)
                setLogsList(logs?.data?.schoolMasterEventLogsAudList)
            }
            
    }

    const saveSchoolHandler = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg)
        }
        try{
            setLoader(true)
        const res = await createSchoolHandler(basicForm, activeContactRows, branchMappingRows)
        setLoader(false)
        if (res?.code == 200) {
            successToast("School added successfully")
            debugger
            const url = `${window.location.origin
                }/#/admin/master/schoolMaster?isView=${true}&schoolId=${res?.data?.id}`;
                setTimeout(() => {
                    history.push(`/admin/master/schoolMaster?isView=${true}&schoolId=${res?.data?.id}`)
                    window.location.reload()
                },1000)
            // Open the new tab with the constructed URL
            
        }
    }
    catch(err){
        console.log(err)
    }
    }
    const editSaveHandler = async (basicForm,editRowForm, updatedObj={}) => {
        const res = await editSchoolHandler(basicForm,editRowForm, schoolId,updatedObj)
        if (res?.code == 200) {
            successToast(res?.message)
            // const url = `${window.location.origin
            //     }/#/admin/master/schoolMaster?isView=${true}&schoolId=${res?.data?.id}`;

            // // Open the new tab with the constructed URL
            // window.open(url, "_self").focus();
            fetchData(type)
        }
    }

    return (
        <>{ userPermissions.length ? loader ? <ALoader position='fixed' /> :
            <div className="large-text mx-5 my-4 label-color">
                <div className=' mb-3 d-flex justify-content-between align-items-center'>
                    <span className='large-text label-color'>
                        <IconButtonWrapper onClick={() => window.close()}>
                            <BackIcon />
                        </IconButtonWrapper>
                        {isView ? `${basicForm?.name} (${basicForm?.id})` : 'Add a new school'}
                    </span>
                    {!isView && <AButton
                        variant="primary_filled"
                        // className="w-full"
                        onClick={() => {
                            saveSchoolHandler()
                        }}
                        disabled={!checkValidation(basicForm, activeContactRows, branchMappingRows)}

                    >
                        Save school
                    </AButton>}
                </div>
                <BasicDetail editSaveHandler={editSaveHandler}
                    basicForm={basicForm}
                    setBasicForm={setBasicForm}
                    isView={isView}
                    dropdown={dropdown}
                    basicDetailRowFormHandler={basicDetailRowFormHandler}
                    rowForm={rowForm}
                    setRowForm={setRowForm}
                    branchMappingRows={branchMappingRows}
                    activeContactRows={activeContactRows}
                />
                <ActiveContact dropdown={dropdown}
                    activeContactRows={activeContactRows}
                    setActiveContactRows={setActiveContactRows}
                    setRowForm={setRowForm}
                    rowForm={rowForm}
                    editSaveHandler={editSaveHandler}
                    isView={isView}
                    basicForm={basicForm}
                    branchMappingRows={branchMappingRows}
                />
                <BranchMapping
                    dropdown={dropdown}
                    branchMappingRows={branchMappingRows}
                    setBranchMappingRows={setBranchMappingRows}
                    setRowForm={setRowForm}
                    rowForm={rowForm}
                    editSaveHandler={editSaveHandler}
                    isView={isView}
                    activeContactRows={activeContactRows}
                    basicForm={basicForm}
                />
                {isView && <Logs 
                rowList={logsList}
                getDetailLogs={getDetailLogs}
                rowCount={logsRowCount}
                />}
            </div>:
            <PermisionDenied />
        }
        </>

    )
}
export default SchoolInfo;